const isIpad = (window: Window) =>
  Boolean(window.navigator.userAgent.match(/iPad/i));

export default isIpad;
